import { render, staticRenderFns } from "./Form_rycctjb.vue?vue&type=template&id=2836458f"
import script from "./Form_rycctjb.vue?vue&type=script&lang=js"
export * from "./Form_rycctjb.vue?vue&type=script&lang=js"
import style0 from "./Form_rycctjb.vue?vue&type=style&index=0&id=2836458f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports